module.exports = __webpack_public_path__ + "static/media/well.323d4f88.png";